import React, { useState } from "react";
import { useConsultationLogic } from './DocteurLogic';
import { FaBookOpen } from "react-icons/fa6";
import { BsMic, BsFillPlusCircleFill } from "react-icons/bs";
import './docteur.css';
import { FaPen, FaTrash } from "react-icons/fa";

const Docteur = () => {
  const {
    UserData,
    patientId,
    patientData,
    vitalSignsData,
    loading,
    followUpDate,
    text,
    ToastContainer,
    handleInputChange,
    handleQuickSelect,
    setFollowUpDate
  } = useConsultationLogic();

  const [formData, setFormData] = useState({
    doctor_questions: [
      { label: "What are your symptoms?", value: "" },
      { label: "Date of Birth", type: "date", value: "" }, // Ajout d'un champ de type date
      { label: "Full Name", type: "text", value: "" } // Ajout d'un champ de type texte
    ],
    allergies: [{ label: "Do you have any allergies?", value: "" }],
    medical_history: [{ label: "Describe your medical history.", value: "" }],
    analyses: [{ label: "Analyse", value: "" }],
    clinical_exam: [{ label: "Clinical examinations.", value: "" }],
    diagnosis: [{ label: "Doctor's Diagnosis.", value: "" }],
  });

  // Ajouter un nouvel élément dans un champ spécifique
  const handleAddField = (fieldName, event) => {
    if (event) event.preventDefault();
    setFormData({
      ...formData,
      [fieldName]: [
        ...formData[fieldName],
        { label: `New ${fieldName} ${formData[fieldName].length + 1}`, value: "" }
      ]
    });
  };

  // Modifier la valeur d'un champ spécifique
  const handleFieldChange = (fieldName, index, newValue) => {
    const updatedFields = [...formData[fieldName]];
    updatedFields[index].value = newValue;
    setFormData({ ...formData, [fieldName]: updatedFields });
  };

  // Modifier le label d'un champ spécifique
  const handleLabelEdit = (fieldName, index, newLabel) => {
    const updatedFields = [...formData[fieldName]];
    updatedFields[index].label = newLabel;
    setFormData({ ...formData, [fieldName]: updatedFields });
  };

  // Supprimer un champ spécifique
  const handleRemoveField = (fieldName, index) => {
    const updatedFields = formData[fieldName].filter((_, i) => i !== index);
    setFormData({ ...formData, [fieldName]: updatedFields });
  };

  // Fonction de gestion de la soumission du formulaire
  const handleSubmit = (event) => {
    event.preventDefault();
    // console.log("Form Data:", formData);
    alert(JSON.stringify(formData)); // Afficher les données sous forme de chaîne JSON
  };

  // Fonction de rendu pour les champs dynamiques
  const renderDynamicFields = (fieldName, buttonText) => (
    <div className="dynamic-fields">
      <div style={{ backgroundColor: '#FF980017', padding: '20px', textAlign: 'center', marginBottom: '30px', borderRadius: '10px', fontWeight: 'bold' }}>{buttonText}</div>
      {formData[fieldName].map((field, index) => (
        <div key={index} className="field-wrapper">
          <div className="label-container">
            <input
              style={{ outline: "none" }}
              type="text"
              value={field.label}
              onChange={(e) => handleLabelEdit(fieldName, index, e.target.value)}
              className="editable-label"
            />
            <FaPen className="edit-icon" />
          </div>

          {/* Rendu du champ en fonction de son type */}
          {field.type === "date" ? (
            <input
              style={{ outline: "none" }}
              type="date"
              className="form-control"
              value={field.value}
              onChange={(e) => handleFieldChange(fieldName, index, e.target.value)}
            />
          ) : field.type === "text" ? (
            <input
              style={{ outline: "none" }}
              type="text"
              className="form-control"
              value={field.value}
              onChange={(e) => handleFieldChange(fieldName, index, e.target.value)}
            />
          ) : (
            <textarea
              style={{ outline: "none" }}
              className="form-control"
              value={field.value}
              onChange={(e) => handleFieldChange(fieldName, index, e.target.value)}
            />
          )}

          <button
            type="button"
            className="btn btn-danger"
            onClick={() => handleRemoveField(fieldName, index)}
          >
            <FaTrash />
          </button>
        </div>
      ))}
      <button
        className="btn addquestionbtn"
        onClick={(e) => handleAddField(fieldName, e)}
        type="button"
      >
        <BsFillPlusCircleFill /> Add {buttonText}
      </button>
    </div>
  );

  const renderDynamicTextarea = (fieldName, buttonText) => (
    <div className="dynamic-fields">
      {/* <div style={{ backgroundColor: '#FF980017', padding: '20px', textAlign: 'center', marginBottom: '30px', borderRadius: '10px', fontWeight: 'bold' }}>{buttonText}</div> */}
      {formData[fieldName].map((field, index) => (
        <div key={index} className="field-wrapper">
          <div className="label-container">
            <input
              style={{ outline: "none" }}
              type="text"
              value={field.label}
              onChange={(e) => handleLabelEdit(fieldName, index, e.target.value)}
              className="editable-label"
            />
            <FaPen className="edit-icon" />
          </div>

          {/* Rendu du champ en fonction de son type */}
          {field.type === "date" ? (
            <input
              style={{ outline: "none" }}
              type="date"
              className="form-control"
              value={field.value}
              onChange={(e) => handleFieldChange(fieldName, index, e.target.value)}
            />
          ) : field.type === "text" ? (
            <input
              style={{ outline: "none" }}
              type="text"
              className="form-control"
              value={field.value}
              onChange={(e) => handleFieldChange(fieldName, index, e.target.value)}
            />
          ) : (
            <textarea
              style={{ outline: "none" }}
              className="form-control"
              value={field.value}
              onChange={(e) => handleFieldChange(fieldName, index, e.target.value)}
            />
          )}

          <button
            type="button"
            className="btn btn-danger"
            onClick={() => handleRemoveField(fieldName, index)}
          >
            <FaTrash />
          </button>
        </div>
      ))}
      <button
        className="btn addquestionbtn"
        onClick={(e) => handleAddField(fieldName, e)}
        type="button"
      >
        <BsFillPlusCircleFill /> Add {buttonText}
      </button>
    </div>
  );

  const [medications, setMedications] = useState([
    {
      id: 1,
      name: "Nom du medicament",
      boxes: "1",
      dosage: "Dosage",
      duration: "Duree"
    }
  ]);

  const addNewMedication = () => {
    const newId = medications.length + 1;
    setMedications([...medications, {
      id: newId,
      name: "",
      boxes: "",
      dosage: "",
      duration: ""
    }]);
  };

  const PrescriptionForm = () => (
    <div className="row prescription">
      <div className="w-full max-w-2xl p-4 bg-white rounded-lg div-relative">
        <div className="flex flex-col gap-4">
          {medications.map((medication) => (
            <div key={medication.id} className="medication-entry">
              {/* Top field */}
              <div className="w-full">
                <div className="flex items-center gap-2">
                  <input
                    readOnly
                    type="text"
                    className="text-sm font-medium over-input"
                    placeholder="Name"
                  />
                  <input
                    type="text"
                    className="w-full p-2 border rounded-lg form-control myinput"
                    // defaultValue={medication.name}
                    placeholder="Medication name"
                  />
                </div>
              </div>

              {/* Bottom three fields in a row */}
              <div className="row mleft mt-4">
                {/* Number of boxes */}
                <div className="col">
                  <input
                    readOnly
                    type="text"
                    className="text-sm font-medium over-input"
                    placeholder="Nbr de boites"
                  />
                  <input
                    style={{ border: "none" }}
                    type="text"
                    className="w-full p-2 border rounded-lg form-control myinput"
                    // defaultValue={medication.boxes}
                    placeholder="Number of boxes"
                  />
                </div>

                {/* Dosage */}
                <div className="col">
                  <input
                    readOnly
                    type="text"
                    className="text-sm font-medium over-input"
                    placeholder="Prises"
                  />
                  <input
                    style={{ border: "none" }}
                    type="text"
                    className="w-full p-2 border rounded-lg form-control myinput"
                    // defaultValue={medication.dosage}
                    placeholder="Dosage"
                  />
                </div>

                {/* Duration */}
                <div className="col">
                  <input
                    readOnly
                    type="text"
                    className="text-sm font-medium over-input"
                    placeholder="Durée"
                  />
                  <input
                    style={{ border: "none" }}
                    type="text"
                    className="w-full p-2 border rounded-lg form-control myinput"
                    // defaultValue={medication.duration}
                    placeholder="Duration"
                  />
                </div>
              </div>

              {medication.id !== 1 && (
                <div className="border-b border-gray-200 my-4" />
              )}
            </div>
          ))}

          {/* Add medication button */}
          <button
            className="btn addquestionbtn"
            type="button"
            onClick={addNewMedication}
          >
            <BsFillPlusCircleFill /> Add Medication
          </button>
        </div>
      </div>
    </div>
  );

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="container doctorconsult">
      <ToastContainer />
      <button className="btn btn-primary mb-5" style={{ borderRadius: '5px', padding: '10px 15px' }}>
        View medical history of patient &nbsp;&nbsp;<FaBookOpen style={{ border: '1px solid white', padding: '2px', fontSize: '25px', borderRadius: '5px' }} />
      </button>
      {/* section for recording */}
      <div className='recording d-flex align-items-center mt-4 mb-5'>
        <div className='me-auto'>
          <div className="form-group">
            <label htmlFor="canirecord" className='mb-3'>Patient consent to recording ?</label>
            <br />
            <div className='row'>
              <div className='col'>
                <input
                  style={{ outline: "none" }}
                  type="radio"
                  name="canirecord"
                  value="yes"
                />  Yes
              </div>
              <div className='col'>
                <input
                  style={{ outline: "none" }}
                  type="radio"
                  name="canirecord"
                  value="no"
                  defaultChecked
                />  No
              </div>
            </div>
          </div>
        </div>
        <div className='ms-auto recordingbtn'>
          <button className=""> Start recording <BsMic />
          </button>
        </div>
      </div>

      {/* signs vitals of patients view */}
      <div className='signsvitaux'>
        <div style={{ backgroundColor: '#FF980017', padding: '20px', textAlign: 'center' }}><strong>Registered vital signs</strong></div>
        <div className='allsigns'>
          <div className='divcontent'>Body Temperature :  <span style={{ color: '#EF3826' }}>35.7°C</span> </div>
          <div className='line'></div>
          <div className='divcontent'>Blood pressure :  <span>120/90 mmHgC</span> </div>
          <div className='line'></div>
          <div className='divcontent'>Note :  <span>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's</span> </div>
        </div>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="row g-3 mb-4">
          <div className="col-md-4">
            <input
              style={{ outline: "none" }}
              type="text"
              name="patientId"
              className="form-control"
              value={patientId}
              onChange={handleInputChange}
              readOnly
              required
              hidden
            />
          </div>
        </div>

        {/* Affichage des champs dynamiques */}
        {renderDynamicFields("doctor_questions", "Doctor's Questions")}
        {renderDynamicFields("allergies", "Allergies")}
        {renderDynamicFields("medical_history", "Medical History")}
        {renderDynamicFields("analyses", "Analyses ")}
        {renderDynamicFields("clinical_exam", "Clinical examinations ")}

        {/* signs vitals of patients view */}
        <div style={{ backgroundColor: '#FF980017', padding: '20px', textAlign: 'center', marginBottom: '30px', borderRadius: '10px', fontWeight: 'bold' }}>Diagnosis</div>
        <div className='signsvitaux'>
          <div style={{ backgroundColor: '#0056B317', padding: '20px', textAlign: 'center' }}><strong>AI's generated diagnosis</strong> </div>
          <div className='allsigns' style={{ padding: '0px 20px 25px 20px' }}>
            <div className='divcontent'><strong className='text-decoration-underline'>Suspected Urinary Tract Infection (UTI) </strong><br />
              Based on the severity and duration of the symptoms, it is likely acute bronchitis rather than chronic bronchitis. However, if symptoms persist beyond 3 weeks, further investigations may be necessary to rule out other conditions like asthma or chronic obstructive pulmonary disease (COPD).</div>
          </div>
        </div>
        {renderDynamicTextarea("diagnosis", "Diagnosis field ")}


        <div style={{ backgroundColor: '#FF980017', padding: '20px', textAlign: 'center', marginBottom: '30px', borderRadius: '10px', fontWeight: 'bold' }}>Medical prescriptions</div>
        <div className='signsvitaux'>
          <div style={{ backgroundColor: '#FF980017', padding: '20px', textAlign: 'center' }}><strong>AI's generated prescription</strong> </div>
          <div className='allsigns' style={{ padding: '0px 20px 25px 20px' }}>
            <div className='divcontent'>
              {/* <strong className='text-decoration-underline'>Suspected Urinary Tract Infection (UTI) </strong><br/> */}
              Medications: Nitrofurantoin 100 mg: Take one capsule twice daily for 7 days. Ibuprofen 400 mg: Take one tablet every 8 hours as needed for pain or fever, not exceeding 3 tablets per day. Laboratory Tests: Urinalysis: To confirm the presence of infection and determine the severity. Urine Culture and Sensitivity Test: To identify the specific bacteria causing the infection and determine the appropriate antibiotic. Complete Blood Count (CBC): To check for signs of systemic infection or inflammation. Non-Pharmacological Recommendations: Increase fluid intake to at least 2 liters per day to help flush out the urinary tract. Avoid caffeine, alcohol, and spicy foods, which can irritate the bladder. Follow-Up: Schedule a follow-up appointment in 10 days to review test results and assess treatment progress.
            </div>
          </div>
        </div>

        <PrescriptionForm />

        <div className="mt-4">
          <button type="submit" className="btn btn-primary">
            Enregistrer la consultation
          </button>
        </div>
      </form>
    </div>
  );
};

export default Docteur;
